import SvgSprite from './SvgSprite.svg'

type LogoPropsType = {
  width?: string;
  height: string;
}
export function Logo(props: LogoPropsType) {
  return (
    <svg
      viewBox="0 0 110.45 104.81"
      width={props.width}
      height={props.height}
      xmlns="http://www.w3.org/2000/svg"
      >
      <use xlinkHref={`${SvgSprite}#${'logo'}`} />
    </svg >
  );
}